import React from 'react';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type TableColumns,
  PROGRAMME_TYPE_FILTER,
  type FilterFields,
} from '../Application/components/ApplicationViewList';
import { UploadDialog } from './components';

export const DualJointManagementList: React.FunctionComponent = () => {
  const visibleFilters: FilterFields[] = React.useMemo(
    () => [
      'entryYear',
      'department',
      'programmeType',
      'dualPartnerUniversity',
      'jointpartnerUniversity',
      'partnerCategory',
      'applicantIdentityType',
      'applicantLocalIndicator',
      'scholarshipAppliedByApplicant',
      'hkpfsNo',
      'validHKPFS',
      'fundingScheme',
      'fundingSchemeStatus',
      'applicantSurname',
      'applicantGivenName',
      'applicationEmail',
      'applicationNo',
      'applicationStatus',
    ],
    [],
  );
  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'entryYear',
      'department',
      'applyProgramme',
      'proposedChiefSupervisors',
      'confirmedChiefSupervisor',
      'partnerUniversityCategory',
      'partnerUniversity',
      'partnerUniversityApplicationNo',
      'partnerIsPolyUHomeUniversityIndicator',
      'partnerProposedChiefSupervisor',
      'applicationStatus',
      'applicationStatus',
    ],
    [],
  );

  const listFilter = {
    programmeChoice: {
      programmeType: {
        in: [
          PROGRAMME_TYPE_FILTER.DUAL_PHD_DEGREE_PROGRAMME,
          PROGRAMME_TYPE_FILTER.COLLABORATIVE_PHD_DEGREE_PROGRAMME,
        ],
      },
    },
  };
  const customTools = [<UploadDialog key="custom-dual-nominate" />];

  const filterProps: ApplicationViewListProps['filterProps'] = {
    onlyPaidApplicationStatusList: false,
    visibleFilterFields: visibleFilters,
  };
  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
    minWidth: '1300px',
  };

  const toolsProps: ApplicationViewListProps['toolsProps'] = {
    customTools,
  };

  return (
    <div>
      <ApplicationViewList
        tableProps={tableProps}
        filterProps={filterProps}
        toolsProps={toolsProps}
      />
    </div>
  );
};
